import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import * as BABYLON from "@babylonjs/core";
import * as GUI from "@babylonjs/gui";

import { SceneContext } from './context';
import { KeyboardContext } from './keyboard-context';

const COLOR = "#FF0096";

function makeThumbArea(name, thickness, color, background, curves){
   let rect = new GUI.Ellipse();
       rect.name = name;
       rect.thickness = thickness;
       rect.color = color;
       rect.background = background;
       rect.paddingLeft = "0px";
       rect.paddingRight = "0px";
       rect.paddingTop = "0px";
       rect.paddingBottom = "0px";
   return rect;
}

function buildJoystick (scene, keyboard) {
    let adt = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", scene);
        let sideJoystickOffset = 50;
        let bottomJoystickOffset = -50;
        let xAddPos = 0;
        let yAddPos = 0;

        let leftThumbContainer = makeThumbArea("leftThumb", 2, COLOR, null);
            leftThumbContainer.height = "120px";
            leftThumbContainer.width = "120px";
            leftThumbContainer.isPointerBlocker = true;
            leftThumbContainer.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
            leftThumbContainer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
            leftThumbContainer.alpha = 0.8;
            leftThumbContainer.left = sideJoystickOffset;
            leftThumbContainer.top = bottomJoystickOffset;

        let leftInnerThumbContainer = makeThumbArea("leftInnterThumb", 4, COLOR, null);
            leftInnerThumbContainer.height = "60px";
            leftInnerThumbContainer.width = "60px";
            leftInnerThumbContainer.isPointerBlocker = true;
            leftInnerThumbContainer.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
            leftInnerThumbContainer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;


        let leftPuck = makeThumbArea("leftPuck",0, COLOR, COLOR);
                leftPuck.height = "40px";
                leftPuck.width = "40px";
                leftPuck.isPointerBlocker = true;
                leftPuck.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                leftPuck.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;

           adt.addControl(leftThumbContainer);
           leftThumbContainer.addControl(leftInnerThumbContainer);
           leftThumbContainer.addControl(leftPuck);
           leftPuck.isVisible = false;

        leftThumbContainer.onPointerDownObservable.add(function(coordinates) {
            leftPuck.isVisible = true;
            leftPuck.floatLeft = coordinates.x-(leftThumbContainer._currentMeasure.width*.5)-sideJoystickOffset;
            leftPuck.left = leftPuck.floatLeft;
            leftPuck.floatTop = adt._canvas.height - coordinates.y-(leftThumbContainer._currentMeasure.height*.5)+bottomJoystickOffset;
            leftPuck.top = leftPuck.floatTop*-1;
            leftPuck.isDown = true;
            leftThumbContainer.alpha = 0.9;
        });

        leftThumbContainer.onPointerUpObservable.add(function(coordinates) {
            xAddPos = 0;
            yAddPos = 0;

            keyboard['a'] = false;
            keyboard['d'] = false;
            keyboard['w'] = false;
            keyboard['s'] = false;

            leftPuck.isDown = false;
            leftPuck.isVisible = false;
            leftThumbContainer.alpha = 0.4;
        });

        leftThumbContainer.onPointerMoveObservable.add(function(coordinates) {
            if (leftPuck.isDown) {
                xAddPos = coordinates.x-(leftThumbContainer._currentMeasure.width*.5)-sideJoystickOffset;
                yAddPos = adt._canvas.height - coordinates.y-(leftThumbContainer._currentMeasure.height*.5)+bottomJoystickOffset;
                leftPuck.floatLeft = xAddPos;
                leftPuck.floatTop = yAddPos*-1;
                leftPuck.left = leftPuck.floatLeft;
                leftPuck.top = leftPuck.floatTop;

                keyboard['a'] = xAddPos < -10;
                keyboard['d'] = xAddPos > 10;
                keyboard['w'] = yAddPos > 10;
                keyboard['s'] = yAddPos < -10;
            }
        });

}

const useJoystick = () => {
  const { sceneRef } = useContext(SceneContext);
  const keyboard = useContext(KeyboardContext);

  useEffect(() => {
    if (!sceneRef?.current) { return; }
    buildJoystick(sceneRef.current, keyboard);
  }, [keyboard, sceneRef]);
};

export default useJoystick;
